import styled from 'styled-components';

const BarContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['barContainerStyle', 'animation'].includes(prop),
})`
  width: 100%;
  height: 2.6rem;
  border-radius: 20px;
  overflow: hidden;

  box-shadow:
    inset -3px 3px 3px rgba(0, 0, 0, 0.6),
    inset -3px -3px 3px rgba(0, 0, 0, 0.6);

  ${({ theme }) => theme.Bar.BarContainer};
  ${({ barContainerStyle }) => barContainerStyle};
  ${({ animation }) => animation};
`;

const Progress = styled.div.withConfig({
  shouldForwardProp: (prop) => !['progress', 'progressStyle'].includes(prop),
})`
  height: 2.6rem;
  width: ${({ progress }) => progress}%;
  transition: width 0.5s ease-in-out;
  margin-left: 0 !important;
  margin-right: 0 !important;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  ${({ theme }) => theme.Bar.BarProgress}
  ${({ progressStyle }) => progressStyle}
`;

const BarText = styled.span.withConfig({
  shouldForwardProp: (prop) => !['customStyle'].includes(prop),
})`
  font-weight: 700;
  ${({ theme }) => theme.Bar.Text}
  ${({ customStyle }) => customStyle}
`;

const BarIcon = styled.img.withConfig({
  shouldForwardProp: (prop) => !['customStyle'].includes(prop),
})`
  width: 70px;
  height: 70px;
  position: absolute;
  object-fit: contain;
  z-index: 1;
  ${({ customStyle }) => customStyle}
`;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const TextContainer = styled(Container)`
  position: absolute;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

const BarShineEffect = styled.div.withConfig({
  shouldForwardProp: (prop) => !['progress', 'customStyle'].includes(prop),
})`
  position: absolute;
  top: 0.2rem;
  left: 1rem;
  width: ${({ progress }) => `calc(${progress}% - 20%)`};
  height: 45%;
  background-color: transparent;
  border-radius: 15px;
  transition: width 0.5s ease-in-out;
  ${({ customStyle }) => customStyle}
`;

export { BarContainer, Progress, BarText, BarIcon, TextContainer, Container, BarShineEffect };

